import * as graphql from '@treams/treams-network';

import ConfigurationFieldBoolean from './ConfigurationFieldBoolean';
import ConfigurationFieldCertificate from './ConfigurationFieldCertificate';
import ConfigurationFieldDate from './ConfigurationFieldDate';
import ConfigurationFieldFilter from './ConfigurationFieldFilter';
import ConfigurationFieldMultiSelect from './ConfigurationFieldMultiSelect';
import ConfigurationFieldOAuth2 from './ConfigurationFieldOAuth2';
import ConfigurationFieldSelect from './ConfigurationFieldSelect';
import ConfigurationFieldText from './ConfigurationFieldText';

export default function ConfigurationFieldValue(props: {
	connectorType?: graphql.ConnectorType;
	field: graphql.ConnectorConfigField;
	autoFocus?: boolean;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => Promise<void>;
}) {
	switch (props.field.__typename) {
		case 'ConnectorConfigFieldBoolean':
			return (
				<ConfigurationFieldBoolean
					field={props.field as graphql.ConnectorConfigFieldBoolean & { boolean: boolean }}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldDate':
			return (
				<ConfigurationFieldDate
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldText':
			return (
				<ConfigurationFieldText
					autoFocus={props.autoFocus}
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldMultiSelect':
			return (
				<ConfigurationFieldMultiSelect
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldOAuth2':
			return (
				<ConfigurationFieldOAuth2
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldCertificate':
			return <ConfigurationFieldCertificate field={props.field} onChange={props.onChange} />;
		case 'ConnectorConfigFieldSelect':
			return (
				<ConfigurationFieldSelect
					connectorType={props.connectorType!}
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		case 'ConnectorConfigFieldFilter':
			return (
				<ConfigurationFieldFilter
					connectorType={props.connectorType!}
					field={props.field}
					change={props.change}
					onChange={props.onChange}
				/>
			);
		default:
			return null;
	}
}
